// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { eventService } from "./EventService";
import { storageService } from "./StorageService";
import { getRuntimeEnv } from "../config/runtimeConfig";

const StorageKeyName = "configuration";

class ConfigService {

  constructor() {
    const initConfig = async () => {
      this._config = await this.getConfig();
    };
    initConfig();
  }

  setConfig(config) {
    this._config = config;
    storageService.setLocalStorageObject(StorageKeyName, config);
    eventService.publishClearCache();
  }

  getConfig() {
    if (this._config) {
      return Promise.resolve(this._config);
    }

    const localStorageConfig = storageService.getLocalStorageObject(StorageKeyName);
    if (localStorageConfig && localStorageConfig.appAdtUrl) {
      return Promise.resolve(localStorageConfig);
    }

    const defaultUrl = getRuntimeEnv("REACT_APP_BASE_ADT_URL", getRuntimeEnv("VITE_API_DIGITALTWIN", "http://localhost:8080"));
    if (defaultUrl) {
      const runtimeConfigObj = { ...(localStorageConfig || {}), appAdtUrl: defaultUrl };
      return Promise.resolve(runtimeConfigObj);
    }

    return new Promise((resolve, reject) => {
      const callback = evt => {
        if (evt.type === "end") {
          eventService.unsubscribeConfigure(callback);
          if (evt.config) {
            this.setConfig(evt.config);
            resolve(evt.config);
          } else {
            const e = new Error("Configuration aborted");
            e.errorCode = "user_cancelled";
            reject(e);
          }
        }
      };

      eventService.subscribeConfigure(callback);
      // Small delay to ensure that the UI is ready to receive the event
      setTimeout(() => {
        eventService.publishConfigure({ type: "start" });
      }, 1000);
    });
  }

}

export const configService = new ConfigService();
